module.exports = __webpack_public_path__ + "static/img/banner.8839e9a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/index/banner.png
// module id = ebLl
// module chunks = 1